import { tns } from 'tiny-slider/src/tiny-slider';

export default function () {
  const SLIDER_CONTAINER_SELECTOR = '.slider__tiny-slider';

  const tinySliderContainer = document.querySelector(SLIDER_CONTAINER_SELECTOR);
  const swipeAngle = 45;

  let slider; // eslint-disable-line no-unused-vars

  if (tinySliderContainer !== null) {
    slider = tns({
      container: tinySliderContainer,
      loop: false,
      autoWidth: false,
      controls: false,
      fixedWidth: 260,
      gutter: 16, // 1em
      items: 1,
      mouseDrag: true,
      nav: false,
      swipeAngle,
      controlsContainer: '.slider__controls',
      responsive: {
        768: {
          fixedWidth: false,
          controls: true,
          items: 3,
          gutter: 20,
        },
      },
    });
  }
}
